import { grayPalette } from '../../themes/colors';

export const headerLightTheme = {
  backgroundColor: grayPalette[0],
};
